import { useContext, useEffect, useState } from 'react'
import Logo from "../../../src/assets/logo.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { DataProvider } from '../../store/ContextProvider';
import { passwordValidator } from '../../utils/validator';
import CustomInput from '../../layouts/ui/CustomInput';
import { AuthFormWrapper } from '../../components/Authentication/AuthFormWrapper';
import { Button } from '../../layouts/ui/Button';
import { ResetService } from '../../services/Authentication/ResetService';
import { AlertMessage } from '../../layouts/ui/AlertMessage';

export const ResetPassword = () => {
    const { BeURL } = useContext(DataProvider)
    const location = useLocation();
    const { form ,otp} = location.state || {};
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [isValid, setIsValid] = useState(false);
    const [message, Setmessage] = useState(null)
    const [confirm, setConfirm] = useState(false)
    const navigate = useNavigate()

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newErrors = { ...errors };

        if (name === "password") {
            setPassword(value);
            newErrors.password = passwordValidator(value);

            // check match with confirmPassword
            if (confirmPassword && value !== confirmPassword) {
                newErrors.confirmPassword = "Passwords do not match";
            } else {
                newErrors.confirmPassword = "";
            }
        }

        if (name === "confirmPassword") {
            setConfirmPassword(value);

            // check match with password
            if (password && value !== password) {
                newErrors.confirmPassword = "Passwords do not match";
            } else {
                newErrors.confirmPassword = "";
            }
        }

        setErrors(newErrors);
    };

    // validate all fields
    useEffect(() => {
        if (
            form?.email &&
            password &&
            !errors.password &&
            confirmPassword &&
            !errors.confirmPassword &&
            password === confirmPassword
        ) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [form, password, confirmPassword, errors]);


    const handleResetPassword = () => {
        if (!isValid) return
        ResetService({ email: form.email, password, BeURL, otp, setConfirm, Setmessage });
    }

    if (confirm) {
        navigate('/login')
    }
    return (
        <AuthFormWrapper>
            <div className="w-full max-w-md space-y-10 py-8 px-6 sm:px-8 lg:px-10">
                <div className='flex justify-center '>
                    <img src={Logo} alt='' className="h-[40px] md:h-[60px] lg:h-[100px] w-auto" />
                </div>

                <div className='space-y-2 text-center'>
                    <p className="text-2xl text-gray-600 font-bold text-center">Create Your new Password</p>
                    <p className="text-sm text-gray-500">Create a strong password to keep your account secure.</p>
                </div>
                <form className="max-w-md mx-auto mt-10 space-y-5">
                    <CustomInput
                        label="Enter New Password"
                        mandatory
                        name="password"
                        value={password}
                        onChange={handleChange}
                        error={errors.password}
                        type="password"
                        placeholder="New Password"
                        required
                        className={"w-full"}
                    />
                    <CustomInput
                        label="Re-Enter New Password"
                        mandatory
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        error={errors.confirmPassword}
                        type="password"
                        placeholder="Confirm New Password"
                        required
                        className={"w-full"}
                    />
                </form>
                <div className='flex justify-center'>
                    <Button disabled={!isValid} variant="primary" onClick={handleResetPassword} className="w-60 h-12 text-white" children={"Reset Password"} />
                </div>
            </div>
            {message && (
                <AlertMessage message={message} confirm={confirm} />
            )}
        </AuthFormWrapper>
    )
}
